"use strict";
// Hook from https://usehooks-ts.com/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useEventListener_1 = __importDefault(require("./useEventListener"));
function useOnClickOutside(ref, handler, mouseEvent = 'mousedown') {
    (0, useEventListener_1.default)(mouseEvent, (event) => {
        const el = ref === null || ref === void 0 ? void 0 : ref.current;
        // Do nothing if clicking ref's element or descendent elements
        if (!el || el.contains(event.target)) {
            return;
        }
        handler(event);
    });
}
exports.default = useOnClickOutside;
